import { useState, type FormEvent } from "react";
import { t } from "../lib/i18n";
import { reportProblem } from "../lib/track";
import { Alert, Button } from "./Form";

/** "Lapor masalah" link in the footer: the message goes straight to the admin's report list. */
export function ReportProblem() {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [state, setState] = useState<"ok" | "fail" | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    const ok = await reportProblem("bug", text.trim());
    setBusy(false);
    setState(ok ? "ok" : "fail");
    if (ok) setText("");
  }

  return (
    <>
      <button type="button" onClick={() => { setOpen(true); setState(null); }} className="underline-offset-4 hover:underline">
        {t("Lapor masalah")}
      </button>
      {open && (
        <div className="fixed inset-0 z-40 grid place-items-center bg-black/40 p-4" role="dialog" aria-modal="true" aria-label={t("Lapor masalah")} onClick={() => setOpen(false)}>
          <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="w-full max-w-md space-y-3 rounded-card bg-surface p-5 text-left shadow-xl">
            <h2 className="text-lg font-semibold">{t("Lapor masalah")}</h2>
            <p className="text-sm text-muted">{t("Terangkan apa yang berlaku. Halaman semasa dihantar sekali supaya kami boleh semak.")}</p>
            <textarea value={text} onChange={(e) => setText(e.target.value)} rows={5} maxLength={2000} required
              placeholder={t("Contoh: Butang muat turun skema tak jalan untuk Sains Tahun 4.")}
              className="w-full rounded-md border border-surface-line bg-surface p-2 text-sm" />
            {state === "ok" && <Alert kind="success">{t("Terima kasih! Laporan anda sudah dihantar.")}</Alert>}
            {state === "fail" && <Alert kind="error">{t("Laporan tidak dapat dihantar. Cuba lagi.")}</Alert>}
            <div className="flex justify-end gap-2">
              <Button type="button" variant="secondary" onClick={() => setOpen(false)}>{t("Tutup")}</Button>
              <Button type="submit" busy={busy} disabled={!text.trim()}>{t("Hantar")}</Button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
